module.exports = __webpack_public_path__ + "static/media/techview-yellow.78c60ee1.svg";